import apiClient from '../apiClient';
import { UPLOAD_PREVIEW_RESTAURANT_PRICE_URL } from '../apiUrl';

const uploadMasterDataPreviewRestaurantPriceApi = data => {
  return apiClient.post(UPLOAD_PREVIEW_RESTAURANT_PRICE_URL, data);
};

export default uploadMasterDataPreviewRestaurantPriceApi;
